module.exports = __webpack_public_path__ + "static/media/skull-still1.075af3fb.png";